import React from "react";
import "../styles_css/Menu.css";
import { useLocation, Link } from "react-router-dom";

const Menu = ({ setIsMenuOpen }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Projects", path: "/projects" },
    { name: "Empowering", path: "/empowering" },
    { name: "About us", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <ul className="custom-menu">
      {menuItems.map((item) => (
        <li
          key={item.name}
          className={`menu-item ${currentPath === item.path ? "active" : ""}`}
        >
          <Link
            to={item.path}
            className={currentPath === item.path ? "active" : ""}
            onClick={() => setIsMenuOpen(false)}
          >
            <span>{item.name}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Menu;

